var Enum = Enum || {};

Enum.STATUS_REASON_TYPE = {
	ACTIVE: 'ACTIVE',
	INACTIVE: 'INACTIVE',
	BLOCKED: 'BLOCKED',
	DELETED: 'DELETED'
};

Object.freeze(Enum.STATUS_REASON_TYPE);